import { FC } from 'react';
import { Box, Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import { useMediaUp } from 'hooks';
import { LineIcon } from '../../../../svgs/gpm';

interface ImpactBlockProps {
  title: string;
  description: string;
  listItems: Array<{ boldText: string; text: string }>;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(10, 3, 10),
    justifyContent: 'center',
    backgroundColor: '#1B2839',
    marginBottom: theme.spacing(5),
    marginTop: 0,
    [theme.breakpoints.up('sm')]: {
      paddingLeft: theme.spacing(4),
    },
    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing(15),
      padding: theme.spacing(17, 3),
    },
    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(17, 39),
    },
    [theme.breakpoints.up('xl')]: {
      padding: theme.spacing(17, 74),
    },
  },
  title: {
    marginBottom: theme.spacing(1),
    fontWeight: 700,
    color: theme.palette.common.white,
    fontSize: 50,
    textAlign: 'center',
    [theme.breakpoints.up('sm')]: {
      textAlign: 'left',
      fontSize: 90,
      marginBottom: theme.spacing(3),
    },
  },
  description: {
    marginBottom: theme.spacing(5),
    fontWeight: 400,
    color: '#F9FBFF',
    fontSize: 10,
    maxWidth: 534,
    textAlign: 'center',
    [theme.breakpoints.up('sm')]: {
      textAlign: 'left',
      fontSize: 20,
      marginBottom: theme.spacing(0),
    },
  },
  boldText: {
    fontWeight: 700,
    color: '#F9FBFF',
    fontSize: 52,
    marginRight: theme.spacing(3),
    [theme.breakpoints.up('sm')]: {
      fontSize: 60,
    },
  },
  text: {
    fontWeight: 400,
    color: '#F9FBFF',
    fontSize: 16,
    [theme.breakpoints.up('sm')]: {
      fontSize: 15,
    },
  },
  box: {
    transition: 'all .6s ease-out',
    cursor: 'pointer',
    '&:hover': {
      border: '2px solid #fff',
    },
  },
}));

const ImpactBlock: FC<ImpactBlockProps> = ({ title, listItems, description }) => {
  const classes = useStyles();
  const isSmallUp = useMediaUp('sm');
  const isMediumUp = useMediaUp('md');

  return (
    <Grid className={classes.root} spacing={isSmallUp ? 6 : 0} justifyContent={'space-between'} alignItems={'center'} container>
      <Grid style={{ position: 'relative' }} xs={12} md={6} item>
        <Typography className={classes.title}>{title}</Typography>
        <Typography className={classes.description}>{description}</Typography>
        {isMediumUp && (
          <Box position={'absolute'} right={0} top={-50}>
            <LineIcon style={{ transform: 'rotate(90deg) scale(1.4)' }} />
          </Box>
        )}
      </Grid>
      <Grid xs={12} md={6} item>
        {listItems.map((item, index) => (
          <Box
            className={classes.box}
            border={'2px solid #154545'}
            borderRadius={'0 24px 0 24px'}
            height={isSmallUp ? 128 : 159}
            padding={isSmallUp ? 8 : '18px 24px'}
            bgcolor={'#FFFFFF0D'}
            marginY={'10px'}
            key={index}
            display={isSmallUp ? 'flex' : 'block'}
            alignItems={'center'}
          >
            <Typography className={classes.boldText}>{item.boldText}</Typography>
            <Typography className={classes.text}>{item.text}</Typography>
          </Box>
        ))}
      </Grid>
    </Grid>
  );
};

export default ImpactBlock;
